import React, { useState } from 'react';
import { Button } from '../ui/Button';

export const CreateIndustryProfileForm = ({ busy, onCancel, onSubmit }) => {
  const [profileKey, setProfileKey] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      profileKey: profileKey.trim(),
      displayName: displayName.trim(),
      description: description.trim()
    });
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <label className="grid gap-1.5 text-sm font-semibold text-slate-700">
        Profilnøkkel
        <input
          required
          value={profileKey}
          onChange={(event) => setProfileKey(event.target.value)}
          placeholder="for eksempel overnatting-servering"
          className="rounded-xl border border-slate-200 px-4 py-3 font-normal outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
        />
      </label>
      <label className="grid gap-1.5 text-sm font-semibold text-slate-700">
        Profilnavn
        <input
          required
          value={displayName}
          onChange={(event) => setDisplayName(event.target.value)}
          placeholder="Profilens visningsnavn"
          className="rounded-xl border border-slate-200 px-4 py-3 font-normal outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
        />
      </label>
      <label className="grid gap-1.5 text-sm font-semibold text-slate-700">
        Beskrivelse
        <textarea
          rows="3"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          placeholder="Valgfri beskrivelse"
          className="resize-y rounded-xl border border-slate-200 px-4 py-3 font-normal outline-none focus:border-blue-400 focus:ring-4 focus:ring-blue-100"
        />
      </label>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="ghost" onClick={onCancel}>Avbryt</Button>
        <Button type="submit" disabled={busy}>{busy ? 'Oppretter …' : 'Opprett utkast'}</Button>
      </div>
    </form>
  );
};